/**
 * Login page, app, or neither — the one decision the `frappe` auth provider's gate makes.
 *
 * Pure so it can be read at a glance and tested without React: the gate itself only feeds it the
 * state of the identity query (`auth.get_current_user`, authorised by the `sid` cookie). There is
 * deliberately no client-side "am I signed in" flag to drift out of step with the server — the
 * cookie is the session, and the server's answer is the truth. A reload asks again.
 *
 * `checking` matters: showing the login page for the instant before the answer lands would put a
 * password prompt in front of someone who is already signed in.
 */
export type LoginGateState = 'checking' | 'login' | 'app'

export function loginGateState(input: { settled: boolean; user: { email: string } | null; failed: boolean }): LoginGateState {
  if (!input.settled) return 'checking'
  if (input.failed || !input.user || input.user.email.trim() === '') return 'login'
  return 'app'
}
